module.exports = __webpack_public_path__ + "static/media/Corn10R5.af91ec2b.png";